export const GOOGLE_STORE_LIST_REQUEST = 'GOOGLE_STORE_LIST_REQUEST';

export const GOOGLE_STORE_UPSERT_REQUEST = 'GOOGLE_STORE_UPSERT_REQUEST';

export const GOOGLE_STORE_INFO_REQUEST = 'GOOGLE_STORE_INFO_REQUEST';

export const GOOGLE_STORE_SORT_UPDATE_REQUEST = 'GOOGLE_STORE_SORT_UPDATE_REQUEST';